import { type OneUxTypographyToken } from '../../generated/design-tokens.js';
import typographies from '../../generated/json/typography/typography.json';
const context = document.createElement('canvas').getContext('2d');
export const getTextSize = (text: string, token: OneUxTypographyToken) => {
  if (!context) {
    return {
      width: NaN,
      fontHeight: NaN,
      actualHeight: NaN
    };
  }
  const typography = typographies[token];
  context.font = `${typography.fontStyle} ${typography.fontWeight} ${typography.fontSize} / ${typography.lineHeight} ${typography.fontFamily}`;
  context.letterSpacing = typography.letterSpacing;
  const metrics = context.measureText(text);
  const width = metrics.width;
  const fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
  const actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
  return {
    width,
    fontHeight,
    actualHeight
  };
};
export const getTextsSize = (texts: string[], token: OneUxTypographyToken) => {
  const sizes: {
    width: number;
    fontHeight: number;
    actualHeight: number;
  }[] = [];
  texts.forEach(text => {
    const size = getTextSize(text, token);
    sizes.push(size);
  });
  return sizes;
};
export const getWrappedTextSize = (lines: string[], token: OneUxTypographyToken) => {
  let width = 0;
  let height = 0;
  lines.forEach(text => {
    const size = getTextSize(text, token);
    width = Math.max(width, size.width);
    height += size.actualHeight;
  });
  return {
    width,
    height
  };
};